import styled from 'styled-components';

import {flipOnLTR} from '~/shared/theme/utils';
import {PriceLabel, PriceLabelWithStrikethrough} from '~/shared/components/PriceLabels';
import {getDishPriceWithDiscount} from '~/shared/utils/priceDiscountCalculator';

const Root = styled.div<{rowReverse?: boolean}>`
  display: flex;
  align-items: flex-end;
  ${({rowReverse}) => rowReverse && 'flex-direction: row-reverse;'}
  ${flipOnLTR`
    padding-right:5px;
  `};
`;

const StyledPriceLabel = styled(PriceLabel)`
  line-height: 1;
`;

const StyledPriceLabelWithStrikethrough = styled(PriceLabelWithStrikethrough)`
  line-height: 1;
`;

type DishPriceProps = {
  price: number;
  addParentheses?: boolean;
  className?: string;
  priceDataTestId?: string;
  discountsData?: ReturnType<typeof getDishPriceWithDiscount>;
  flipOrder?: boolean;
};

const DishPrice = ({price, addParentheses, className, priceDataTestId, discountsData, flipOrder}: DishPriceProps) => (
  <Root className={className} rowReverse={flipOrder}>
    {addParentheses && '('}
    <StyledPriceLabel
      price={discountsData ? discountsData.priceAfterDiscount : price}
      priceDataTestId={priceDataTestId}
      bold={!!discountsData}
    />
    {discountsData && <StyledPriceLabelWithStrikethrough price={discountsData.price} marginRight={!flipOrder} priceDataTestId="modalDishPriceBeforeDiscount" />}
    {addParentheses && ')'}
  </Root>
);

export default DishPrice;
